const POPOVER_CLOSING_SELECTOR = '[data-close-popover]';
const HOVER_CLOSABLE_TRIGGER_VALUE = 'hover-closable';

const POPOVER_CLOSE_BUTTON_HTML_CONTENT = `<button data-close-popover class="close-button small"></button>`;

Hop.defineModule('popover', (root, param) => {
    const $root = $(root);
    const $popovers = $root.find('[data-toggle="popover"]');

    class Popover {
        constructor(node) {
            this._node = node;
            this._$node = $(node);

            this._onShow = this._onShow.bind(this);
            this._onHide = this._onHide.bind(this);
            this._onClickClosingCta = this._onClickClosingCta.bind(this);
            this._handleShowAndHideFoHoverClosableTooltip = this._handleShowAndHideFoHoverClosableTooltip.bind(this);
        }

        createPopover() {
            const template = [
                `<div class="popover ${param.customClass} ${param.color} ${param.size}" role="tooltip">`,
                `<div class="arrow"></div>`,
                `<h3 class="popover-title"></h3>`,
                `<div class="popover-content"></div>`,
                `${this._node.getAttribute('data-trigger') === HOVER_CLOSABLE_TRIGGER_VALUE ? POPOVER_CLOSE_BUTTON_HTML_CONTENT : ''}`,
                `</div>`,
            ];

            this._$node.popover({
                template: template.join(''),
                sanitize: param.sanitize || false,
            });

            if (this._$node.attr('data-trigger') === HOVER_CLOSABLE_TRIGGER_VALUE) {
                this._setUpHoverClosableTooltip();
            }

            this._$node.on('show.bs.popover', this._onShow);
            this._$node.on('hide.bs.popover', this._onHide);

            return this;
        }

        destroyPopover() {
            this._$node.off('show.bs.popover', this._onShow);
            this._$node.off('hide.bs.popover', this._onHide);
            this._$node.popover('destroy');

            this._node.removeEventListener('mouseover', this._handleShowAndHideFoHoverClosableTooltip);

            const popoverClosingCta = this._findPopoverClosingCta();
            if (popoverClosingCta) {
                popoverClosingCta.removeEventListener('click', this._onClickClosingCta);
            }

            return this;
        }

        _onShow() {
            this._$node.addClass('open');
        }

        _onHide() {
            this._$node.removeClass('open');
        }

        _setUpHoverClosableTooltip() {
            this._node.addEventListener('mouseover', this._handleShowAndHideFoHoverClosableTooltip);
        }

        _findPopoverClosingCta() {
            const id = this._node.getAttribute('aria-describedby');
            if (id) {
                const popoverCtaRelatedTooltip = document.querySelector(`#${id}`);
                return popoverCtaRelatedTooltip.querySelector(POPOVER_CLOSING_SELECTOR);
            }
        }

        _handleShowAndHideFoHoverClosableTooltip() {
            this._$node.popover('show');

            const popoverClosingCta = this._findPopoverClosingCta();
            if (popoverClosingCta) {
                popoverClosingCta.removeEventListener('click', this._onClickClosingCta);
                popoverClosingCta.addEventListener('click', this._onClickClosingCta);
            }
        }

        _onClickClosingCta() {
            this._$node.popover('hide');
        }
    }

    function onShown(e) {
        $popovers.filter('.open').not(e.target).popover('hide');
    }

    function onHidden(e) {
        $(e.target).data('bs.popover') && ($(e.target).data('bs.popover').inState.click = false);
    }

    function onClickDoc(e) {
        if (!$(e.target).parents('.popover').length && !$(e.target).closest('[data-toggle="popover"]').length) {
            hideOpenPopovers();
        }
    }

    function hideOpenPopovers() {
        $popovers.filter('.open').popover('hide');
    }

    if ($popovers.length && typeof $popovers.popover === 'function') {
        $popovers.each((idx, node) => {
            $(node).data('malt.popover', new Popover(node).createPopover());
        });

        $(document).on('shown.bs.popover', onShown);
        $(document).on('click', onClickDoc);

        // Fix bug bootstrap => http://stackoverflow.com/questions/32581987/need-click-twice-after-hide-a-shown-bootstrap-popover?answertab=active#tab-top
        $(document).on('hidden.bs.popover', onHidden);
    }

    return function () {
        $popovers.each((idx, node) => {
            const popover = $(node).data('malt.popover');
            if (popover) {
                popover.destroyPopover();
            }
        });

        $(document).off('shown.bs.popover', onShown);
        $(document).off('shown.bs.popover', onHidden);
        $(document).off('click', onClickDoc);
    };
});
